// 행에 "평가 완료" 를 찍어도 되는지 판정한다.
//
// assess_yn 단독으로는 쓸 수 없다. 매일 01시 크론 handleUnfulfilled 가 마감이 지난 미이행 건을
// assess_yn='Y', score=0 으로 바꿔 두기 때문이다(대상 조건이 execute_yn='N'). 2026-10-27 dev 실측으로
// assess_yn='Y' 3,976건 중 3,930건이 이 크론이 찍은 행이었고, 사람이 평가한 것은 execute_yn='Y' 44건뿐이다.
// 그 행까지 평가 완료로 찍으면 사진을 낸 적 없는 매장이 평가된 것으로 읽힌다.
//
// score 는 보지 않는다. 이행평가 피드백 업로드(VMD-389)가 score 를 NULL 로 남기므로 점수 유무로는
// 업로드로 평가된 매장을 가려낼 수 없다.
export const isAssessed = (item: {
  assess_yn?: string | null;
  execute_yn?: string | null;
  score?: number | null;
}): boolean => item.assess_yn === "Y" && item.execute_yn === "Y";
